import { Example } from "./Example";

import styles from "./Example.module.css";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    { 
        text: "How to reset my portal PIN?", value: "How to reset my portal PIN?"
    },
    {
        text: "I can't connect to HKUVPN with my UID, why?", value: "I can't connect to HKUVPN with my UID, why?"
    },
    {
        text: "How to print using the uPrint service?", value: "How to print using the uPrint service?"
    },
    {
        text: "How to get WiFi connection in HKU?", value: "How to get WiFi connection in HKU?"
    },
    {
        text: "Why students cannot see my course in Moodle?", value: "Why students cannot see my course in Moodle?"
    }
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
